import API from "../utils/apiCalling";
import {
    config,
} from "../utils/apiUrl";


const api =
    new API();


export const loginService =
    async (
        payload
    ) => {

        const response =
            await api.post(
                config.tenantLogin,
                payload,
                false
            );

        return response;
    };


export const sendAdminForgotPasswordOtpService =
    async (
        payload
    ) => {

        return api.post(
            config.adminForgotPasswordSendOtp,
            payload,
            false
        );
    };


export const verifyAdminForgotPasswordOtpService =
    async (
        payload
    ) => {

        return api.post(
            config.adminForgotPasswordVerifyOtp,
            payload,
            false
        );
    };


export const resetAdminForgotPasswordService =
    async (
        payload
    ) => {

        return api.post(
            config.adminForgotPasswordReset,
            payload,
            false
        );
    };


export const getProfileService =
    async () => {

        const response =
            await api.get(
                config.getTenantProfile,
                true
            );

        return response;
    };


export const logoutService =
    async () => {

        const response =
            await api.post(
                config.logout,
                {},
                true
            );

        return response;
    };
